import {
  defaultAppearanceConfig,
  defaultAppearanceConfigKeys,
} from 'apps/cdp-web-demo/app/data/config';
import { AppearanceAppConfig, ConfigState, ThemeConfig } from 'apps/cdp-web-demo/app/types';

export function configStateToAppearanceConfig(
  state: ConfigState,
): AppearanceAppConfig & ThemeConfig {
  return {
    accentColor: state.accentColor,
    appLogoUrl: state.config.appLogoUrl,
    appName: state.config.appName,
    borderRadius: state.borderRadius,
    customColor: state.customColor,
    fontFamily: state.fontFamily,
    showCoinbaseFooter: state.config.showCoinbaseFooter,
    themeMode: state.themeMode,
  };
}

export function isDefaultAppearanceConfig(config: ConfigState): boolean {
  const appearanceConfig = configStateToAppearanceConfig(config);
  for (const key of defaultAppearanceConfigKeys) {
    const k = key as keyof (AppearanceAppConfig & ThemeConfig);
    if (appearanceConfig[k] !== defaultAppearanceConfig[k]) {
      return false;
    }
  }
  return true;
}
